export enum ContactFormTheme {
    Card = "card",
}
